var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  rx: 22,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.4219 27.7644C19.7344 28.0785 20.2656 28.0785 20.5781 27.7644L29.7656 18.5288C30.0781 18.2147 30.0781 17.6806 29.7656 17.3665L28.6406 16.2356C28.3281 15.9215 27.8281 15.9215 27.5156 16.2356L20.0156 23.7749L16.4844 20.2565C16.1719 19.9424 15.6719 19.9424 15.3594 20.2565L14.2344 21.3874C13.9219 21.7016 13.9219 22.2356 14.2344 22.5497L19.4219 27.7644Z",
  fill: "white"
})));
export default SvgCheckLarge;